import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import "./cabina.css";

const fmt = (v) => (v == null ? "—" : `$${Math.round(Number(v)).toLocaleString("es-MX")}`);

const I = {
  open: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14"><path d="M9 6l6 6-6 6" /></svg>,
  dollar: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" /></svg>,
};

export default function CabinaTableroCostos() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [subtab, setSubtab] = useState("pendiente");
  const [canal, setCanal] = useState("");
  const [counts, setCounts] = useState({ pendiente: 0, capturado: 0, validado: 0 });

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/cabina/costos/pendientes`, { params: { estatus: subtab, canal } });
      setRows(r.data.rows || []);
      // Load counts for all subtabs
      const [pP, pC, pV] = await Promise.all([
        axios.get(`${API}/cabina/costos/pendientes`, { params: { estatus: "pendiente", canal } }),
        axios.get(`${API}/cabina/costos/pendientes`, { params: { estatus: "capturado", canal } }),
        axios.get(`${API}/cabina/costos/pendientes`, { params: { estatus: "validado", canal } }),
      ]);
      setCounts({ pendiente: pP.data.total || 0, capturado: pC.data.total || 0, validado: pV.data.total || 0 });
    } catch (e) { toast.error("Error"); }
  }, [subtab, canal]);

  useEffect(() => { load(); }, [load]);

  const diasDesde = (fechaStr) => {
    if (!fechaStr) return "—";
    const d = new Date(fechaStr);
    const dias = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
    return dias;
  };

  return (
    <div className="cv" data-testid="cabina-tablero-costos">
      <div className="head">
        <div>
          <h2>Bandeja de costos</h2>
          <p>Administración captura el costo del proveedor y valida el tratamiento fiscal. Dos pasos, siempre.</p>
        </div>
        <div className="spacer" />
        <label className="f" style={{ minWidth: 200 }}><span>Canal</span>
          <select value={canal} onChange={(e) => setCanal(e.target.value)} data-testid="filtro-canal">
            <option value="">Todos</option>
            <option value="business">Business</option>
            <option value="groups">Groups</option>
            <option value="directo">Directo</option>
            <option value="socio">Socio</option>
          </select>
        </label>
      </div>

      <div className="card">
        <div className="cv-subtabs" style={{ padding: "0 18px", marginBottom: 0 }}>
          <button className={subtab === "pendiente" ? "on" : ""} onClick={() => setSubtab("pendiente")} data-testid="subtab-pendiente">Sin costo <span className="badge">{counts.pendiente}</span></button>
          <button className={subtab === "capturado" ? "on" : ""} onClick={() => setSubtab("capturado")} data-testid="subtab-capturado">Por validar <span className="badge">{counts.capturado}</span></button>
          <button className={subtab === "validado" ? "on" : ""} onClick={() => setSubtab("validado")} data-testid="subtab-validado">Validadas <span className="badge">{counts.validado}</span></button>
        </div>
        <div className="tw">
          <table className="dense">
            <thead><tr>
              <th className="nw">Servicio</th>
              <th>Cliente</th>
              <th>Categoría</th>
              <th className="nw">Localizador</th>
              <th className="nw">Ámbito</th>
              <th className="r nw">Venta</th>
              <th className="r nw">Costo</th>
              <th className="r nw">Utilidad</th>
              <th className="r nw">Margen</th>
              <th className="r nw">Días</th>
              <th className="r nw" style={{ width: "1%" }} />
            </tr></thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={11} className="empty"><b>Nada en esta bandeja</b>{subtab === "pendiente" ? "No hay servicios sin costo" : subtab === "capturado" ? "No hay costos pendientes de validar" : "Aún no hay costos validados"}</td></tr>}
              {rows.map((s) => (
                <tr key={s.id} className="click" onClick={() => nav(`/cabina-ventas/expediente/${s.expediente_id}`)}>
                  <td className="nw"><b style={{ color: "var(--cv-blue)", fontFamily: "'IBM Plex Mono',monospace" }}>{s.expediente_folio}</b><div className="s">{s.folio}</div></td>
                  <td>{s.cliente_nombre || "—"}<div className="s">{s.fecha_venta}</div></td>
                  <td>{s.categoria_nombre}<div className="s">{s.descripcion || "—"}</div></td>
                  <td>{s.localizador ? <span className="loc">{s.localizador}</span> : <span style={{ color: "var(--cv-ghost)" }}>—</span>}</td>
                  <td className="nw"><span className="s" style={{ margin: 0 }}>{s.ambito_fiscal}</span></td>
                  <td className="r nw mono">{fmt(s.venta_total_mxn)}</td>
                  <td className="r nw mono">{fmt(s.costo_total_mxn)}</td>
                  <td className="r nw mono" style={{ color: "var(--cv-blue)" }}>{fmt(s.fiscal?.utilidad_total)}</td>
                  <td className="r nw mono">{s.fiscal?.margen_pct ?? "—"}%</td>
                  <td className="r nw mono" style={{ color: "var(--cv-ghost)" }}>{diasDesde(s.fecha_venta)}</td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <div className="ibs">
                      <button className="ib" title="Abrir expediente" onClick={() => nav(`/cabina-ventas/expediente/${s.expediente_id}`)}>{I.open}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
